import { censusReportPath } from './constants';
import { baseAutomationUrl } from 'src/config';
import { getAccessToken, getRealmName } from 'src/routes/AuthContext';
import { ICensusPullParams } from './types';
import axios from 'axios';
import { getClientIpHeader } from 'src/services/clientIpService/getClientIp';

export const getPullCensusReport = async (body: ICensusPullParams) => {
  const token = await getAccessToken();
  const realm = getRealmName() ?? '';
  const getFacilityUuid = localStorage.getItem('facilityId');

  if (getFacilityUuid && getFacilityUuid.length) {
    body.facility_uuid = getFacilityUuid;
  }

  body.enterprise_name = realm;
  body.batch_type = 'CENSUS';
  body.upload_to_s3 = false;
  body.return_pdf = true;

  const url = `${baseAutomationUrl}${censusReportPath.PULL}`;

  return axios.post(url, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(await getClientIpHeader()),
    },
    responseType: 'arraybuffer',
  });
};
